import KfzModelEdit from "../components/KfzModelEdit";
import {connect} from "react-redux";
import {push} from "react-router-redux";
import {isOnline} from "../actions/userActions";
import {createKfzModel, fetchKfzList} from "../actions/kfzActions";
import isFunc from 'lodash/isFunction';
import {showSnackbar} from "../actions/snachbarActions";
import {makeRoute, ROUTE_KFZ_EDIT} from "../routes";
import {isProcessing} from "../actions/processingActions";
import {PROC_KFZ} from "../actions";

const m2s = (state, props) => {
	const kfz_id = Number(props.match.params.kfz_id);
	return {
		kfz: state.kfz.list.find(k => k.kfz_id === kfz_id),
		isSaving: isProcessing(state, PROC_KFZ, kfz_id)
	};
};
const m2d = (dispatch, props) => {
	const kfz_id = Number(props.match.params.kfz_id);
	dispatch(isOnline(() => {
		dispatch(fetchKfzList(kfz_id));
	}));
	return {
		push: to => dispatch(push(to)),
		onSave: (kfz, model, onSuccess) => dispatch(createKfzModel(kfz, model, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(push(makeRoute(ROUTE_KFZ_EDIT, {kfz_id: kfz.kfz_id || kfz})));
			dispatch(showSnackbar('snackbar.kfz.model.created'));
		}))
	};
};

export default connect(m2s, m2d)(KfzModelEdit);


// WEBPACK FOOTER //
// ./src/containers/KfzModelCreateController.js